import { useState, useEffect, FormEvent } from 'react';

import Loading from './Loading';
import GameBoard from './GameBoard';

import './MarbleSkip.css';

export type PlaceHolders = 'b' | 'm' | 'o';
export type Game = PlaceHolders[][]
export type Coord = { i: number, j: number };

const GameBoardsTemplate: ({ board: Game, marbles: number })[] = [
  {
    board: [
      ['b', 'b', 'm', 'm', 'm', 'b', 'b'],
      ['b', 'b', 'm', 'm', 'm', 'b', 'b'],
      ['m', 'm', 'm', 'm', 'm', 'm', 'm'],
      ['m', 'm', 'm', 'o', 'm', 'm', 'm'],
      ['m', 'm', 'm', 'm', 'm', 'm', 'm'],
      ['b', 'b', 'm', 'm', 'm', 'b', 'b'],
      ['b', 'b', 'm', 'm', 'm', 'b', 'b'],
   ],
   marbles: 32
  },
  { 
    board: [
      ['b', 'b', 'm', 'm', 'm', 'b', 'b'],
      ['b', 'm', 'm', 'm', 'm', 'm', 'b'],
      ['m', 'm', 'm', 'm', 'm', 'm', 'm'],
      ['m', 'm', 'm', 'o', 'm', 'm', 'm'],
      ['m', 'm', 'm', 'm', 'm', 'm', 'm'],
      ['b', 'm', 'm', 'm', 'm', 'm', 'b'],
      ['b', 'b', 'm', 'm', 'm', 'b', 'b'],
    ],
    marbles: 36
  },
  {
    board: [
      ['b', 'm', 'b', 'b', 'b', 'm', 'b'],
      ['m', 'm', 'm', 'm', 'm', 'm', 'm'],
      ['b', 'm', 'm', 'm', 'm', 'm', 'b'],
      ['b', 'm', 'm', 'o', 'm', 'm', 'b'],
      ['b', 'm', 'm', 'm', 'm', 'm', 'b'],
      ['m', 'm', 'm', 'm', 'm', 'm', 'm'],
      ['b', 'm', 'b', 'b', 'b', 'm', 'b'],
    ],
    marbles: 32
  },
  {
    board: [
      ["m", "m", "m", "o", "o"],
      ["m", "m", "m", "m", "m"],
      ["m", "m", "m", "m", "m"],
      ["o", "m", "m", "m", "m"],
      ["o", "m", "m", "m", "m"]
    ],
    marbles: 21
  }
];

function MarbleSkip() {
  const [loading, setLoading] = useState(true);
  const [game, setGame] = useState<Game>();
  const [gameBoardIndex, setGameBoardIndex] = useState<number>();
  const [marbles, setMarbles] = useState(0);
  const [captured, setCaptured] = useState(0);
  const [lost, setLost] = useState(false);
  const [won, setWon] = useState(false);
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    // @ts-ignore
    const touchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
    setIsTouch(touchDevice);
    setGameBoardIndex(0);
  }, []);

  useEffect(() => {
    setLoading(true);
    if (typeof gameBoardIndex === 'number') {
      initGame();
    }
    setLoading(false);
  }, [gameBoardIndex]);


  const initGame = () => {
    if (typeof gameBoardIndex === 'number') {
      const gameTemplate = GameBoardsTemplate[gameBoardIndex];
      const dims = gameTemplate.board.length;
      setMarbles(gameTemplate.marbles);
      setCaptured(0);
      const board: Game = [];
      for(let r = 0; r < dims; r++) {
        const row: PlaceHolders[] = [];
        board.push(row);
        for(let c = 0; c < dims; c++) {
          row.push(gameTemplate.board[r][c]);
        }
      }
      setGame(board);
    }
  };

  const moveMarble = (marbleCoord: Coord, toCoord: Coord, captureMarble: Coord) => {
    const nextGameState = game as Game;
    nextGameState[marbleCoord.i][marbleCoord.j] = 'o';
    nextGameState[toCoord.i][toCoord.j] = 'm';
    nextGameState[captureMarble.i][captureMarble.j] = 'o';
    setCaptured(captured +1);
    setGame(nextGameState);
  };

  const resetGame = () => {
    initGame();
    setLost(false);
    setWon(false);
  };

  const selectBoard = (e:FormEvent<HTMLSelectElement>) => {
    // @ts-ignore
    setGameBoardIndex(parseInt(e.target.value || 0));
  };

  return <>
    {loading && <Loading />}
    {!loading &&
      <div className="mine-main">
        <div className="spacer"></div>
        {/* <div className="space-around">
          Game: {won ? 'Won!' : lost ? 'Lost!' : 'Playing'}
        </div> */}
        <div className="space-around">Marbles: {marbles}</div>
        <div className="space-around">Captured: {captured}</div>
        <div className="spacer"></div>
      </div>
    }
    {!loading &&
      <div className="mine-main">
        <div className="spacer"></div>
        <GameBoard 
          game={game} 
          lost={lost} 
          won={won} 
          moveMarble={moveMarble}
        />
        <div className="spacer"></div>
      </div>
    }
    
    {!loading && /*(won||lost) && */
      <div className="mine-main">
        <div className="spacer"></div>
        <div className="space-around"><button onClick={resetGame}>Reset</button></div>
        <div className="space-around">
          <select value={gameBoardIndex} onInput={selectBoard}>
            <option value="0">Plus</option>
            <option value="1">Octagon</option>
            <option value="2">Wierd</option>
            <option value="3">Unsolvable</option>
          </select>
        </div>
        <div className="spacer"></div>
      </div>
    }
  </>;
}


export default MarbleSkip;